import React, { ReactNode, useEffect, useState } from "react";
import { useWallet, ConnectModal } from "@suiet/wallet-kit";
import CustomWalletInfo from "./CustomWalletInfo"; // Adjust import path as needed
import { BaseError } from "@suiet/wallet-sdk";
import classnames from "classnames";

export type CustomConnectButtonProps = {
  label?: string;
  children?: ReactNode;
  onConnectSuccess?: (walletName: string) => void;
  onConnectError?: (error: BaseError) => void;
  onDisconnectSuccess?: (walletName: string) => void;
  onDisconnectError?: (error: BaseError) => void;
  className?: string;
  style?: React.CSSProperties;
};

export const CustomConnectButton = (props: CustomConnectButtonProps) => {
  const { label = "Connect Button" } = props;
  const [showModal, setShowModal] = useState(false);
  const { connected } = useWallet();

  useEffect(() => {
    if (connected) {
      setShowModal(false);
    }
  }, [connected]);

  return (
    <ConnectModal
      open={showModal}
      onOpenChange={(open) => {
        if (connected) return;
        setShowModal(open);
      }}
      onConnectSuccess={props.onConnectSuccess}
      onConnectError={props.onConnectError}
    >
      <div>
        {connected ? (
          <CustomWalletInfo
            className={classnames(props.className)}
            style={props.style}
            onDisconnectSuccess={(name: string) => {
              setShowModal(false);
              props?.onDisconnectSuccess?.(name);
            }}
            onDisconnectError={props.onDisconnectError}
          />
        ) : (
          <button
            className={classnames("wkit-button", props.className)}
            style={props.style}
          >
            {props.children || label}
          </button>
        )}
      </div>
    </ConnectModal>
  );
};

export default CustomConnectButton;